import type { NavItem } from '@/types'

export const mainNavigation: Array<NavItem> = [
    { label: 'Home', href: '/#hero', section: 'hero' },
    { label: 'Services', href: '/#services', section: 'services' },
    { label: 'Our Work', href: '/#work', section: 'work' },
    { label: 'About', href: '/#about', section: 'about' },
    { label: 'Contact', href: '/#contact', section: 'contact' }
]

export const serviceNavigation: Array<NavItem> = [
    { label: 'Website Design & Development', href: '/#service-web' },
    { label: 'Music Promotion & Digital Marketing', href: '/#service-promotion' },
    { label: 'Branding & Visual Identity', href: '/#service-branding' },
    { label: 'Creative Direction & Digital Experiences', href: '/#service-direction' }
]

export const legalNavigation: Array<NavItem> = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' }
]

export const START_PROJECT_HREF = '/#contact'
